$(function() {
    if (!$('.js-category-filters-breakpoint').length) return;

    $(addElToWrap($('.js-header'), 'js-category-filters-breakpoint'))
        .wrapAll('<div class="header__sticky-area"></div>');
});

function addElToWrap(element, lastEl, arr = [element[0]]) {
    while (!$(element).next().hasClass(lastEl)) {
        arr.push($(element).next()[0]);

        element = $(element).next()[0];
    }

    return arr;
}

$(window).on('load', function() {
    const $checkpointInfo = $('.js-information-order__head');

    if (!$($checkpointInfo).length) return;

    toggleSecondHeader({
        header: $('.js-header'),
        stickyBlocks: $('.js-information__sticky'),
        startPoint: $checkpointInfo,
        breakpoint: 1180
    });
});

function toggleSecondHeader({ header, startPoint, stickyBlocks, breakpoint }) {
    const headerHeight = $(header).height();
    let startShow = $(startPoint).offset().top;
    let scrolled = $(document).scrollTop();
    let topIndent = startShow - (scrolled + headerHeight);

    const mapToggleClass = {
        true: () => {
            let elementHeight = $(stickyBlocks).outerHeight()

            $(stickyBlocks).addClass('is-show');
        },

        false: () => {
            $(stickyBlocks).removeClass('is-show');
        }
    };

    $(document).scroll(function() {
        if (breakpoint > $(window).outerWidth()) {
            return clearBlocks([stickyBlocks, header]);
        }

        scrolled = $(document).scrollTop();

        mapToggleClass[scrolled >= startShow]();

        if (startShow - headerHeight > scrolled) {
            return clearBlocks([stickyBlocks, header]);
        }

        topIndent = startShow - scrolled - headerHeight;

        return stopCalculation(header, headerHeight, topIndent);
    });

    $(window).resize(function() {
        if (breakpoint > $(window).outerWidth()) {
            return clearBlocks([stickyBlocks, header]);
        }

        scrolled = $(document).scrollTop();
        startShow = $(startPoint).offset().top;

        return mapToggleClass[scrolled >= startShow]();
    });

    if (breakpoint > $(window).outerWidth()) {
        return clearBlocks([stickyBlocks, header]);
    }

    mapToggleClass[scrolled >= startShow]();

    if (startShow - headerHeight > scrolled) {
        return clearBlocks([stickyBlocks, header]);
    }

    return stopCalculation(header, headerHeight, topIndent);
}

function clearBlocks(inputArr) {
    for (let i = 0; i < inputArr.length; i++) {
        $(inputArr[i]).removeAttr('style');
        $(inputArr[i]).removeClass('is-show');
    }
}

function stopCalculation(element, elementHeight, topIndent) {
    if ((elementHeight / -1) > topIndent) {
        return $(element).css('top', elementHeight / -1);
    }

    $(element).css('top', topIndent);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/second-header.js